import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEs419: CultureInfo = {
  name: 'es-419',
  displayName: 'Spanish (Latin America)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-419',
  parent: CultureInfoEs
};
